import AddAdvertiserContainer from 'modules/advertisers/containers/AddAdvertiserContainer';

const AddAdvertiserView = () => <AddAdvertiserContainer />;

export default AddAdvertiserView;
